import { CLIENTDASHBOARDJOBCOUNT } from "../ENVIRONMENT";

// api for dashboardjob count
function dashboardJobCount(token) {
  const response = fetch(CLIENTDASHBOARDJOBCOUNT, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${
        token ? token : sessionStorage.getItem("token")
      }`,
    },
  });
  return response;
}

export { dashboardJobCount };
